import api from "../index";

export const GetWalletApi = (userId, params) => api.get(`WalletMaster/Get-WalletDetailsByRule/${userId}?${params}`);
export const WalletToAccountTransferApi = (data) => api.post('WalletMaster/Internal-Transfer-Wallet-to-Terminal', data);
export const AccountToWalletTransferApi = (data) => api.post('WalletMaster/Internal-Transfer-Terminal-to-Wallet', data);
export const InternalTransferApi = (data) => api.post('WalletMaster/Internal-Transfer', data);
export const GetMT5AccountsApi = (params) => api.get(`UserMaster/MT5Account-ByUserId/${params}`);
export const GetAllwalletinternalTransferApi = (params) => api.get(`WalletMaster/Get-Internal-Withdrawal-Request?${params}`);